import React from 'react';
export default class BaseComponent extends React.Component {
    _bind(...methods) {
        methods.forEach(m => this[m] = this[m].bind(this));
    }
}
